// extracted by mini-css-extract-plugin
export var connectionButton = "_c1-1";
export var connectionButtonFloating = "_c1-2";
export var connectionContainer = "_c1-0";
export var rightPanel = "_c1-6";
export var stepCard = "_c1-3";
export var stepCardSubtitle = "_c1-5";
export var stepCardText = "_c1-4";